import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { InputCheckbox, Typography, Label, Alert } from 'shared/ui'
import { LINK_HELP_QUIET_HOURS } from 'shared/constants/links'
import { QuietHoursTimePicker } from 'pages/settings/pages/doubleOptIn/ui/QuietHoursSettings/ui/QuietHoursTimePicker/QuietHoursTimePicker'
import { DoubleOptInPageContext } from 'pages/settings/pages/doubleOptIn/context/doubleOptInContext'
import { QuietHoursTable } from 'pages/settings/pages/doubleOptIn/ui/QuietHoursSettings/ui/QuietHoursTable/QuietHoursTable'
import styles from './styles.module.scss'

export const QuietHoursSettings = observer(() => {
  const store = useContext(DoubleOptInPageContext)

  if (!store || !store.quietHoursStore || !store.quietHoursStore.quietHoursEnabled) return null

  const {
    quietHoursBlockOnWeekend,
    getTime,
    setTime,
    changeIsBlockOnWeekend,
    violatesFederalLawRecommendation,
  } = store.quietHoursStore

  return (
    <div className={styles.wrap}>
      {violatesFederalLawRecommendation && (
        <Alert
          marginBottom={16}
          item={{
            type: 'warning',
            desc: 'US federal law allows messages and calls only between 8:00 AM and 9:00 PM in the recipient’s local time zone. Some states may enforce stricter quiet hours.',
          }}
          rightActions={[
            {
              variant: 'button',
              type: 'primary',
              text: 'Learn more',
              onClick: () => {
                window.open(LINK_HELP_QUIET_HOURS, '_blank')
              },
            },
          ]}
        />
      )}
      <div className={styles.timeDropdownList}>
        <div className={styles.timeDropdown}>
          <Label
            label={{
              text: (
                <Typography
                  ariaLabel={'Stop sending or calling label'}
                  variant={'text-input-label-small'}
                  color={'var(--content-primary-tertiary)'}
                  className={styles.label}
                >
                  Stop sending or calling
                </Typography>
              ),
            }}
          />
          <QuietHoursTimePicker field='end' getTime={getTime} setTime={setTime} />
        </div>
        <div className={styles.timeDropdown}>
          <Label
            label={{
              text: (
                <Typography
                  ariaLabel={'Resume sending оr calling'}
                  variant={'text-input-label-small'}
                  color={'var(--content-primary-tertiary)'}
                  className={styles.label}
                >
                  Resume sending оr calling
                </Typography>
              ),
            }}
          />
          <QuietHoursTimePicker field='start' getTime={getTime} setTime={setTime} />
        </div>
      </div>
      <InputCheckbox
        checked={quietHoursBlockOnWeekend}
        className={styles.checkbox}
        color='var(--content-primary-primary)'
        customLabel={
          <Typography
            ariaLabel={'is block on weekend'}
            variant={'body-md-regular'}
            color='var(--content-primary-primary)'
          >
            Block outbound messages and calls on Saturday and Sunday
          </Typography>
        }
        onChecked={() => changeIsBlockOnWeekend(!quietHoursBlockOnWeekend)}
      />
      <QuietHoursTable />
    </div>
  )
})
